import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import AutoBetListPopup from '../../../components/web/autoBetListPopup';
import AmountListIcon from '../../../components/web/amountListIcon';
import GambleIcon from '../../../components/web/gambleIcon';
import SpinButton from '../../../components/web/spinButton';
import GameSpeed from '../../../components/web/gameSpeed';
import AutoBetIcon from '../../../components/web/autoBetIcon';
import { BetSection } from '../../../components/web/betSection';
import ClassicQuickBetsListPopup from '../../../components/web/classicQuickBetsListPopup';
import { isMobile } from '../../../core/helpers/isMobile';

const ClassicBettingPartWrapper = observer(() => {
  const {
    quickBetsListPopup,
    autoBetListPopup,
    betSection,
    spinButton,
    amountListIcon,
    gambleIcon,
    gameSpeed,
    autoBetIcon,
  } = useMemo(() => {
    return {
      quickBetsListPopup: {
        x: isMobile() ? 0 : 379,
        y: isMobile() ? 33 : 656,
        text: {
          x: isMobile() ? 262 : 341,
          y: isMobile() ? 27 : 27,
        },
        quickBetsList: {
          x: isMobile() ? 62 : 75,
          y: isMobile() ? 34 : 36,
          elementMargin: isMobile() ? 100 : 132,
        },
        pagination: {
          x: isMobile() ? 260 : 340,
          y: isMobile() ? 92 : 96,
          elementMargin: isMobile() ? 58 : 54,
        },
      },
      autoBetListPopup: {
        x: isMobile() ? 79 : 1396,
        y: isMobile() ? 285 : 757,
      },
      betSection: {
        x: isMobile() ? 51 : 444,
        y: isMobile() ? 130 : 766,
        quickBetMargin: isMobile() ? 105 : 138,
      },
      spinButton: {
        x: isMobile() ? 270 : 1250,
        y: isMobile() ? 261 : 690,
      },
      amountListIcon: {
        x: isMobile() ? 384 : 1097,
        y: isMobile() ? 297 : 766,
      },
      gambleIcon: {
        x: isMobile() ? 460 : 1154,
        y: isMobile() ? 297 : 766,
      },
      gameSpeed: {
        x: isMobile() ? 156 : 1345,
        y: isMobile() ? 297 : 766,
      },
      autoBetIcon: {
        x: isMobile() ? 78 : 1401,
        y: isMobile() ? 297 : 766,
      },
    };
  }, []);

  return (
    <Container className='BettingPart'>
      <ClassicQuickBetsListPopup
        x={quickBetsListPopup.x}
        y={quickBetsListPopup.y}
        text={quickBetsListPopup.text}
        pagination={quickBetsListPopup.pagination}
        quickBetsList={quickBetsListPopup.quickBetsList}
      />
      <BetSection x={betSection.x} y={betSection.y} quickBetMargin={betSection.quickBetMargin} />
      <AutoBetListPopup x={autoBetListPopup.x} y={autoBetListPopup.y} />
      <SpinButton x={spinButton.x} y={spinButton.y} />
      <AmountListIcon x={amountListIcon.x} y={amountListIcon.y} />
      <GambleIcon x={gambleIcon.x} y={gambleIcon.y} />
      <GameSpeed x={gameSpeed.x} y={gameSpeed.y} />
      <AutoBetIcon x={autoBetIcon.x} y={autoBetIcon.y} />
    </Container>
  );
});
export default ClassicBettingPartWrapper;
